<section class="remote-support">
  @if (grant && snapshot && inSession) {
    <!-- Session with a terminal -->
    <div class="card remote-support__card">
      <div class="card__header remote-support__session-header">
        <div class="remote-support__session-info">
          <span class="remote-support__eyebrow">{{ 'remote-support.session.terminal' | translate }}</span>
          <span class="remote-support__serial">{{ grant.serial }}</span>
          @if (grant.software; as software) {
            <span class="remote-support__muted">
              {{ 'remote-support.software' | translate: { platform: software.platform, version: software.version } }}
            </span>
          }
        </div>

        <div class="remote-support__session-state">
          <span class="remote-support__status" role="status" aria-live="polite">{{ statusKey | translate }}</span>
          @if (snapshot.path === 'direct') {
            <span class="remote-support__pill remote-support__pill--active">
              {{ 'remote-support.session.path-direct' | translate }}
            </span>
          } @else if (snapshot.path === 'relay') {
            <span class="remote-support__pill remote-support__pill--waiting">
              {{ 'remote-support.session.path-relay' | translate }}
            </span>
          }
          @if (viewOnly) {
            <span class="remote-support__pill remote-support__pill--idle">
              {{ 'remote-support.session.view-only' | translate }}
            </span>
          }
        </div>

        <div class="remote-support__actions">
          <label class="remote-support__preset" [title]="'remote-support.session.preset-hint' | translate">
            <span class="remote-support__eyebrow">{{ 'remote-support.session.preset' | translate }}</span>
            <select class="field__input remote-support__preset-select" [formControl]="presetControl">
              @for (preset of screenPresets; track preset) {
                <option [value]="preset">{{ presetKey(preset) | translate }}</option>
              }
            </select>
          </label>
          <app-button
            color="info"
            size="small"
            icon="agres-fullscreen"
            [title]="'remote-support.session.fullscreen' | translate"
            (btnClick)="toggleFullscreen()">
          </app-button>
          <app-button
            color="danger"
            size="small"
            icon="agres-power"
            [title]="'remote-support.session.end' | translate"
            (btnClick)="endSession()">
          </app-button>
        </div>
      </div>

      <div class="card__body">
        <div #viewer class="remote-support__viewer" [class.remote-support__viewer--rotated]="snapshot.rotated">
          <div #screen class="remote-support__screen"></div>
          @if (snapshot.screen !== 'showing') {
            <div class="remote-support__overlay">
              <p>{{ statusKey | translate }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  } @else if (ended) {
    <!-- The session ended -->
    <div class="card remote-support__card">
      <div class="card__body">
        @if (snapshot?.failure) {
          <div class="notify notify__warning" role="alert">
            <p>{{ endKey | translate }}</p>
          </div>
        } @else {
          <div class="notify notify__info" role="status">
            <p>{{ endKey | translate }}</p>
          </div>
        }
        <div class="remote-support__actions">
          @if (canReconnect) {
            <app-button
              color="primary"
              icon="agres-reload"
              [disabled]="connecting"
              [title]="'remote-support.session.reconnect' | translate"
              (btnClick)="reconnect()">
            </app-button>
          }
          <app-button color="return" [title]="'remote-support.session.start-over' | translate" (btnClick)="startOver()">
          </app-button>
        </div>
      </div>
    </div>
  } @else {
    <!-- Code form -->
    <div class="card remote-support__card">
      <div class="card__header remote-support__card-title">{{ 'remote-support.connect.title' | translate }}</div>
      <div class="card__body">
        <p class="remote-support__hint">{{ 'remote-support.connect.hint' | translate }}</p>
        <div class="remote-support__form">
          <div class="field remote-support__field">
            <label class="field__label" for="remote-support-code">
              {{ 'remote-support.connect.code-label' | translate }}
            </label>
            <input
              #codeInput
              id="remote-support-code"
              class="field__input remote-support__code"
              [formControl]="codeControl"
              [placeholder]="'remote-support.connect.code-placeholder' | translate"
              [attr.aria-invalid]="codeControl.touched && codeControl.invalid"
              aria-describedby="remote-support-code-error"
              autocomplete="off"
              autocapitalize="characters"
              spellcheck="false"
              (keydown.enter)="connect()" />
            @if (codeControl.touched && codeControl.invalid) {
              <span class="field__input--alert" id="remote-support-code-error">
                {{ 'remote-support.connect.code-invalid' | translate }}
              </span>
            }
          </div>
          <app-button
            color="primary"
            icon="agres-link"
            [disabled]="connecting"
            [title]="'remote-support.connect.button' | translate"
            (btnClick)="connect()">
          </app-button>
        </div>
        @if (connectFailure) {
          <div class="notify notify__danger" role="alert">
            <p>{{ connectFailureKey | translate }}</p>
          </div>
        }
      </div>
    </div>
  }
</section>
